.thumb {
    display: flex;
    flex-direction: column;
    min-height: 270px;
    padding: 20px 24px;
    background-color: white;
    border: 1px solid #e3e6eb;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    transition: background-color 0.2s ease;
    &:hover {
        background-color: #e8f0fe;
    }
}

.createdLabel {
    font-size: 14px;
    font-family: Hanken Grotesk;
    color: #98a2b3;
}

.website {
    display: inline-block;
    font-size: 14px;
    font-family: Hanken Grotesk;
    color: #074cb3;
    text-decoration: none;
    white-space: nowrap;
    &:hover {
        font-weight: 600;
    }
}

.cardInner {
    display: flex;
    flex-direction: column;
    flex: 1;
}

// Grows to fill the card; with the row's align-items: stretch every card in a
// row gets the same top-area height, so the dividers line up horizontally.
.topArea {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 22px;
    line-height: 1.3;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #102442;
    margin-top: 16px;
    margin-bottom: 8px;
}

.desc {
    line-height: 1.3;
    font-family: Hanken Grotesk;
    margin-top: 4px;
    margin-bottom: 16px;
    color: rgb(71, 84, 103);
    font-family: 'Hanken Grotesk';
    font-size: 13px;
    font-weight: 400;
}
.divider {
    width: calc(100% + 48px);
    height: 1px;
    border-bottom: 1px dashed #e0e0e0;
    margin-left: -24px;
}

.metaRow {
    padding-top: 20px;
    width: 100%;
    gap: 16px;
    // Reserve room for a two-line Industry value so the divider-to-base
    // distance is constant across cards and the dividers line up in a row.
    box-sizing: content-box;
    min-height: 64px;
}

.fieldContainer {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    // URL column keeps its width; the Industry column yields and wraps.
    flex-shrink: 0;
}

.fieldRight {
    text-align: right;
    align-items: flex-end;
    flex-shrink: 1;
}

.fieldTitle {
    font-size: 14px;
    line-height: 20px;
    font-family: Hanken Grotesk;
    color: #98a2b3;
}

.fieldValue {
    font-size: 14px;
    line-height: 20px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #475467;
}
